import Resource from './Resource.js';

var vwResource = new Resource({
        baseUrl: '/api/visit-windows',
        dates: ['opens_at', 'closes_at'],
        name: 'VisitWindowResourse'
    })
export default vwResource;